export default __webpack_public_path__ + "static/media/Procedimento_de_Filmagens_ZER.7180b347.pdf";